(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apexpul-calming-massager"] && !Shopify.designMode) return;
  try {
    
(function(){
  var W = document.getElementById('apexpul-wrap');
  if (!W) return;

  /* ===== VIDEO SLIDER ===== */
  var currentSlide = 0;
  var totalSlides = 2;
  var centerVids = ['apV2', 'apV5'];

  function pauseAllVids(){
    ['apV1','apV2','apV3','apV4','apV5','apV6'].forEach(function(id){
      var v = document.getElementById(id);
      if (v) v.pause();
    });
  }

  function playCenterVid(idx){
    var v = document.getElementById(centerVids[idx]);
    if (v) { v.muted = true; try { v.play(); } catch(e){} }
  }

  function goToSlide(idx){
    currentSlide = idx;
    pauseAllVids();
    var track = document.getElementById('apVidTrack');
    if (track) track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    var dots = W.querySelectorAll('.ap-dot');
    dots.forEach(function(d, i){ d.style.background = i === idx ? '#1A1A1A' : '#ccc'; });
    setTimeout(function(){ playCenterVid(idx); }, 450);
  }

  document.addEventListener('click', function(e){
    var nav = e.target.closest('#apexpul-wrap .ap-nav');
    if (nav) {
      var dir = parseInt(nav.getAttribute('data-dir'));
      goToSlide((currentSlide + dir + totalSlides) % totalSlides);
      return;
    }
    var dot = e.target.closest('#apexpul-wrap .ap-dot');
    if (dot) {
      var idx = parseInt(dot.getAttribute('data-dot'));
      if (!isNaN(idx)) goToSlide(idx);
      return;
    }
    var overlay = e.target.closest('#apexpul-wrap .ap-vid-overlay');
    if (overlay) {
      var vidId = overlay.getAttribute('data-vid');
      if (vidId) {
        var v = document.getElementById(vidId);
        if (v) { v.play(); overlay.style.display = 'none'; }
      }
      return;
    }
  });

  // Play center video on load
  if (document.readyState === 'complete') playCenterVid(0);
  else window.addEventListener('load', function(){ playCenterVid(0); });

  /* ===== FAQ ACCORDION ===== */
  document.addEventListener('click', function(e){
    var q = e.target.closest('#apexpul-wrap .ap-faq-q');
    if (!q) return;
    var item = q.closest('.ap-faq-item');
    if (!item) return;
    item.classList.toggle('is-open');
  });

  /* ===== BUY NOW: SCROLL TO PRODUCT FORM ===== */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('#apGotoBuy');
    if (!btn) return;
    e.preventDefault();
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (form) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout-custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const backToTop = document.getElementById('BackToTop');
    if (!backToTop) return;
    
    // 滚动显示/隐藏返回顶部按钮
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }, { passive: true });
    
    // 点击返回顶部
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyeliner-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('fk-eyeliner-wrap');
    if (!root) { return; }

    // Pause offscreen autoplay videos to save resources.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var p = video.play();
            if (p && p.catch) { p.catch(function () {}); }
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '100px' });

      root.querySelectorAll('video').forEach(function (video) {
        io.observe(video);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faux-layered-sweatshirt-content"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.addEventListener('click', function(e){
      var q = e.target.closest('#fls-wrap .fls-faq-q');
      if(!q) return;
      var item = q.closest('.fls-faq-item');
      if(!item) return;
      item.classList.toggle('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fryer-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function frInit(){
      /* ---- Countdown to next midnight (self-contained urgency timer) ---- */
      var cd = document.querySelector('#fr-wrap .fr-countdown');
      if(cd){
        function pad(n){ return (n < 10 ? '0' : '') + n; }
        function tick(){
          var now = new Date();
          var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
          var diff = Math.max(0, end - now);
          var h = Math.floor(diff / 3600000);
          var m = Math.floor((diff % 3600000) / 60000);
          var s = Math.floor((diff % 60000) / 1000);
          cd.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        }
        tick();
        setInterval(tick, 1000);
      }

      /* ---- Sticky bottom bar: show after scrolling ---- */
      var sticky = document.getElementById('frSticky');
      if(sticky){
        function onScroll(){
          if(window.scrollY > 500){ sticky.classList.add('fr-show'); }
          else { sticky.classList.remove('fr-show'); }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', frInit);
    } else {
      frInit();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["high-tack-double-sided-mesh-tape"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ===== FAQ EVENT DELEGATION =====
  document.addEventListener('click', function(e){
    var q = e.target.closest('#dt-wrap .dt-faq-q');
    if(!q) return;
    var item = q.closest('.dt-faq-item');
    item.classList.toggle('is-open');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["korae-eye-cream"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('korae-eye-landing');
    if (!root) return;

    // "Claim Offer" scrolls back to the native add-to-cart form
    var offerBtn = root.querySelector('[data-keb-scroll-offer]');
    if (offerBtn) {
      offerBtn.addEventListener('click', function () {
        var atc = document.querySelector('form[action*="/cart/add"] button[type="submit"]')
          || document.querySelector('form[action*="/cart/add"]');
        if (atc) {
          atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbmlbm-leak-proof"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('#lbmlbm-wrap .lbm-fitem').forEach(function(f){
    f.addEventListener('click',function(){this.classList.toggle('op')});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-principles-bible-content"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function pauseOthers(current) {
      var vids = document.querySelectorAll('#vbc-wrap video.vbc-video');
      for (var i = 0; i < vids.length; i++) {
        if (vids[i] !== current && !vids[i].paused) {
          vids[i].pause();
          var c = vids[i].closest('.vbc-video-card');
          if (c) { c.classList.remove('vbc-playing'); }
        }
      }
    }

    function setPlaying(video, playing) {
      var card = video.closest('.vbc-video-card');
      if (!card) { return; }
      if (playing) {
        card.classList.add('vbc-playing');
      } else {
        card.classList.remove('vbc-playing');
      }
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('#vbc-wrap .vbc-play-btn');
      if (btn) {
        var card = btn.closest('.vbc-video-card');
        var video = card ? card.querySelector('video.vbc-video') : null;
        if (video) {
          pauseOthers(video);
          video.play();
        }
        return;
      }
      var video = e.target.closest('#vbc-wrap video.vbc-video');
      if (video) {
        if (video.paused) {
          pauseOthers(video);
          video.play();
        } else {
          video.pause();
        }
      }
    });

    document.addEventListener('play', function(e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('vbc-video')) {
        pauseOthers(t);
        setPlaying(t, true);
      }
    }, true);

    document.addEventListener('pause', function(e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('vbc-video')) {
        setPlaying(t, false);
      }
    }, true);

    document.addEventListener('ended', function(e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('vbc-video')) {
        setPlaying(t, false);
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marine-corps-bag-content"] && !Shopify.designMode) return;
  try {
    
(function(){
  // FAQ accordion
  document.addEventListener('click', function(e){
    var q = e.target.closest('#mcb-wrap .mcb-faq-q');
    if(!q) return;
    var item = q.closest('.mcb-faq-item');
    if(!item) return;
    var wasOpen = item.classList.contains('mcb-open');
    item.classList.toggle('mcb-open');
    if(wasOpen){
      var details = item.querySelector('details');
      if(details) details.removeAttribute('open');
    }
  });

  // BTS Carousel
  var wrap = document.getElementById('mcb-wrap');
  if(!wrap) return;
  var slider = wrap.querySelector('.mcb-bts-slider');
  if(!slider) return;
  var track = slider.querySelector('.mcb-bts-track');
  var cards = slider.querySelectorAll('.mcb-bts-card');
  var prevBtn = slider.querySelector('.mcb-bts-prev');
  var nextBtn = slider.querySelector('.mcb-bts-next');
  var dotsContainer = slider.querySelector('.mcb-bts-dots');
  if(!track || !cards.length) return;

  var currentIndex = 0;
  var totalSlides = cards.length;

  // Build dots
  for(var i = 0; i < totalSlides; i++){
    var dot = document.createElement('li');
    dot.className = 'mcb-bts-dot';
    dot.setAttribute('role','button');
    dot.setAttribute('aria-label','Go to slide ' + (i+1));
    dot.setAttribute('data-index', i);
    if(i === 0) dot.classList.add('mcb-active');
    dotsContainer.appendChild(dot);
  }

  function getSlidesPerView(){
    return window.innerWidth >= 750 ? 3 : 2;
  }

  function getMaxIndex(){
    return Math.max(0, totalSlides - getSlidesPerView());
  }

  function getScrollOffset(index){
    if(!cards[0]) return 0;
    var cardWidth = cards[0].offsetWidth;
    var gap = window.innerWidth >= 750 ? 28 : 12;
    return index * (cardWidth + gap);
  }

  function goToSlide(index){
    index = Math.max(0, Math.min(index, getMaxIndex()));
    currentIndex = index;
    track.scrollLeft = getScrollOffset(index);
    updateDots();
  }

  function updateDots(){
    var dots = dotsContainer.querySelectorAll('.mcb-bts-dot');
    for(var i = 0; i < dots.length; i++){
      if(i === currentIndex){
        dots[i].classList.add('mcb-active');
      } else {
        dots[i].classList.remove('mcb-active');
      }
    }
  }

  // Watch scroll to update dots
  var scrollTimeout;
  track.addEventListener('scroll', function(){
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function(){
      var cardWidth = cards[0].offsetWidth;
      var gap = window.innerWidth >= 750 ? 28 : 12;
      var idx = Math.round(track.scrollLeft / (cardWidth + gap));
      idx = Math.max(0, Math.min(idx, getMaxIndex()));
      if(idx !== currentIndex){
        currentIndex = idx;
        updateDots();
      }
    }, 50);
  }, {passive:true});

  prevBtn.addEventListener('click', function(){
    goToSlide(currentIndex - 1);
  });
  nextBtn.addEventListener('click', function(){
    goToSlide(currentIndex + 1);
  });

  // Dot clicks (delegated)
  dotsContainer.addEventListener('click', function(e){
    var dot = e.target.closest('.mcb-bts-dot');
    if(!dot) return;
    var idx = parseInt(dot.getAttribute('data-index'), 10);
    if(!isNaN(idx)) goToSlide(idx);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smooche-ccf"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('ccf-landing');
    if (!root) return;

    // Accordion toggle
    root.querySelectorAll('.ccf-faq-item').forEach(function (item) {
      var q = item.querySelector('.ccf-faq-q');
      if (q) {
        q.addEventListener('click', function () {
          item.classList.toggle('ccf-open');
        });
      }
    });

    // "Shop now" scrolls back to the native add-to-cart form
    root.querySelectorAll('[data-ccf-scroll-offer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var atc = document.querySelector('form[action*="/cart/add"] button[type="submit"]')
          || document.querySelector('form[action*="/cart/add"]');
        if (atc) {
          atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turtle-charm-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function dupTickers(){
    var tickers = document.querySelectorAll('#tlc-wrap .tlc-ticker__track');
    for(var i = 0; i < tickers.length; i++){
      var track = tickers[i];
      var items = Array.prototype.slice.call(track.children);
      for(var j = 0; j < items.length; j++){
        track.appendChild(items[j].cloneNode(true));
      }
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', dupTickers);
  } else {
    dupTickers();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
